<template>
  <b-modal
    title="ویرایش تخفیف جدید"
    id="modal-discount-edit"
    no-close-on-backdrop
    centered
    ok-title="ویرایش"
    cancel-title="انصراف"
    @cancel="closeModal"
    @ok.prevent="updateADiscount"
  >
    <b-container fluid>
      <b-form-row>
        <b-col cols="12" md="6">
          <b-form-group
            label="نوع تخفیف را انتخاب کنید"
            label-for="discount-type"
          >
            <b-form-select
              size="sm"
              id="discount-type"
              :options="discountTypes"
              v-model="discountDetails.type"
              placeholder="نوع تخفیف"
            ></b-form-select>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="6">
          <b-form-group :label="discountValueLabel" label-for="discount-type">
            <b-form-input
              size="sm"
              id="discount-type"
              v-model="discountDetails.value"
              :placeholder="discountValuePlaceholder"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="6">
          <b-form-group label="تاریخ شروع تخفیف" label-for="discountStart">
            <b-form-input
              class="startDateEdit"
              size="sm"
              :value="createJalaliDate(discountDetails.startDate)"
              id="discountStart"
              placeholder="تاریخ شروع تخفیف را وارد کنید"
            ></b-form-input>
            <date-picker
              v-model="discountDetails.startDate"
              class="absolute"
              customInput=".startDateEdit"
              display-format="jYYYY/jMM/jDD"
              input-format="jYYYY/jMM/jDD"
              format="YYYY-MM-DD HH:mm:ss"
            ></date-picker>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="6">
          <b-form-group label="تاریخ اتمام تخفیف" label-for="discountExpire">
            <b-form-input
              class="expireEdit"
              size="sm"
              id="discountExpire"
              :value="createJalaliDate(discountDetails.expireDate)"
              placeholder="تاریخ اتمام تخفیف را وارد کنید"
            ></b-form-input>
            <date-picker
              v-model="discountDetails.expireDate"
              class="absolute"
              customInput=".expireEdit"
              display-format="jYYYY/jMM/jDD"
              input-format="YYYY/MM/DD"
              format="YYYY-MM-DD HH:mm:ss"
            ></date-picker>
          </b-form-group>
        </b-col>
        <b-col :cols="isLessonDiscount ? 6 : 12">
          <course-picker
            :defaultCourseId="discountDetails.courseId"
            @getCourse="setCourseId"
          ></course-picker>
        </b-col>
        <b-col cols="6" v-if="isLessonDiscount">
          <lesson-picker
            :isDisabled="!tempCourseId"
            :defaultCourseId="tempCourseId"
            @getLesson="setLessonId"
          ></lesson-picker>
        </b-col>
      </b-form-row>
    </b-container>
  </b-modal>
</template>
<script>
import CoursePicker from "../MasterActiveCourse/CoursePicker.vue";
import LessonPicker from "../Lessons/LessonPicker.vue";
import { UpdateADiscount } from "@/libs/Api/Discount";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

import {
  BModal,
  BContainer,
  BRow,
  BCol,
  BFormRow,
  BFormGroup,
  BFormInput,
  BFormSelect,
} from "bootstrap-vue";
export default {
  emits: ["reFetch"],
  props: {
    discountFor: {
      type: String,
      default: "course",
      validator(value) {
        // The value must match one of these strings
        return ["course", "lesson"].includes(value);
      },
    },
    defaultDiscount: {
      type: Object,
      required: true,
    },
  },
  watch: {
    defaultDiscount: {
      immediate: true,
      handler(val) {
        this.discountDetails = JSON.parse(JSON.stringify(val));
        this.discountDetails.expireDate = new Date(
          this.discountDetails.expireDate
        );
      },
    },
  },
  data() {
    return {
      discountTypes: [
        {
          text: "تخفیف درصدی",
          value: 2,
        },
        {
          text: "تخفیف عددی",
          value: 1,
        },
      ],
      discountDetails: null,
      tempCourseId: null,
    };
  },
  methods: {
    createJalaliDate(date) {
      return new Date(date).toLocaleDateString("fa-IR");
    },
    closeModal() {
      this.$bvModal.hide("modal-discount-edit");
    },
    setLessonId(lessonId) {
      this.discountDetails.lessonId = lessonId;
    },
    setCourseId(courseId) {
      this.tempCourseId = courseId;
      if (!this.isLessonDiscount) {
        this.discountDetails.courseId = courseId;
      }
    },
    async updateADiscount() {
      try {
        this.discountDetails.startDate = new Date(
          this.discountDetails.startDate
        );
        if (this.discountDetails.expireDate) {
          this.discountDetails.expireDate = new Date(
            this.discountDetails.expireDate
          );
        }
        let _this = this;
        let updateADiscount = new UpdateADiscount(_this);
        updateADiscount.setRequestParamDataObj(_this.discountDetails);
        await updateADiscount.fetch((response) => {
          if (response.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "تخفیف با موفقیت ویرایش شد",
                icon: "CheckIcon",
                variant: "success",
              },
            });
            _this.$emit("reFetch");
            _this.closeModal();
          }
        });
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "این دوره در تاریخ انتخابی یک تخفیف فعال دارد",
            icon: "AlertCircleIcon",
            variant: "danger",
          },
        });
      }
    },
    // async sendDiscountCreateRequest() {
    //   try {
    //     this.discountDetails.startDate = new Date(
    //       this.discountDetails.startDate
    //     );
    //     if (this.discountDetails.expireDate) {
    //       this.discountDetails.expireDate = new Date(
    //         this.discountDetails.expireDate
    //       );
    //     }
    //     let _this = this;
    //     let createDiscount = new CreateDiscount(_this);
    //     createDiscount.setRequestParamDataObj(_this.discountDetails);
    //     await createDiscount.fetch((response) => {
    //       if (response.isSuccess) {
    //         _this.$toast({
    //           component: ToastificationContent,
    //           props: {
    //             title: "تخفیف با موفقیت ایجاد شد",
    //             icon: "CheckIcon",
    //             variant: "success",
    //           },
    //         });
    //         _this.$emit("reFetch");
    //         _this.closeModal();
    //       }
    //     });
    //   } catch (error) {
    //     // console.error(error.response);
    //     this.$toast({
    //       component: ToastificationContent,
    //       props: {
    //         title: "این دوره در تاریخ انتخابی یک تخفیف فعال دارد",
    //         icon: "AlertCircleIcon",
    //         variant: "danger",
    //       },
    //     });
    //   }
    // },
  },
  computed: {
    discountValueLabel() {
      if (this.discountDetails.type == 1) {
        return "مقدار تخفیف (تومان)";
      } else if (this.discountDetails.type == 2) {
        return "مقدار تخفیف (درصد)";
      }
    },
    discountValuePlaceholder() {
      if (this.discountDetails.type == 1) {
        return "مقدار تخفیف را به تومان وارد کنید";
      } else if (this.discountDetails.type == 2) {
        return "مقدار درصد تخفیف را وارد کنید";
      }
    },
    isLessonDiscount() {
      if (this.discountFor == "lesson") {
        return true;
      }
      return false;
    },
  },
  components: {
    BModal,
    BContainer,
    BRow,
    BCol,
    BFormRow,
    BFormGroup,
    BFormInput,
    BFormSelect,
    CoursePicker,
    LessonPicker,
  },
};
</script>
